import React, { PropTypes } from "react";

export default function PricingView({ quantity, stockUnits, price, showPriceIncl }) {
    return (
      <fieldset className="border-top">
        <div className="box-text">
          {quantity} {stockUnits[quantity !== 1 ? 1 : 0]}
        </div>
        <div className="item-price">
          <span className="price">{price[showPriceIncl ? "incl" : "excl"]}</span>
        </div>
      </fieldset>
    );
}

PricingView.propTypes = {
    price: PropTypes.shape({
        incl: PropTypes.string.isRequired,
        excl: PropTypes.string.isRequired,
    }).isRequired,
    quantity: PropTypes.number.isRequired,
    stockUnits: PropTypes.arrayOf(PropTypes.string).isRequired,
    showPriceIncl: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Views/PricingView.jsx